import React, { useEffect, useState } from "react";
import axios from "axios";

const CategoriesDropdown = ({ setCategory, selectedCategory: initialSelectedCategory }) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(initialSelectedCategory || ""); // Set the initial value

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const token = localStorage.getItem("admin_token"); // Get the token from local storage

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/categories/`, {
          headers: {
            Authorization: `Bearer ${token}`, // Include the Bearer token
          },
        });

        setCategories(response.data);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  useEffect(() => {
    // Update the selectedCategory state when the prop changes
    if (initialSelectedCategory) {
      setSelectedCategory(initialSelectedCategory);
    }
  }, [initialSelectedCategory]);

  const handleChange = (event) => {
    const category = event.target.value;
    setSelectedCategory(category);
    setCategory(category); // Pass the selected category to the parent component
  };

  return (
    <div className="mb-3 w-25 mx-1">
      <select
        id="categories"
        className="form-select"
        value={selectedCategory}
        onChange={handleChange}
      >
        <option value="" disabled className="text-secondary">
          Kategori Seçiniz
        </option>
        {categories.map((category) => (
          <option key={category.id} value={category.id}>
            {category.category_name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CategoriesDropdown;
